import { render, staticRenderFns } from "./Product11-01-006-000012ogmmr.vue?vue&type=template&id=a8157c36"
import script from "./Product11-01-006-000012ogmmr.vue?vue&type=script&lang=js"
export * from "./Product11-01-006-000012ogmmr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8157c36')) {
      api.createRecord('a8157c36', component.options)
    } else {
      api.reload('a8157c36', component.options)
    }
    module.hot.accept("./Product11-01-006-000012ogmmr.vue?vue&type=template&id=a8157c36", function () {
      api.rerender('a8157c36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/deposit/Product11-01-006-000012ogmmr.vue"
export default component.exports